export default {
  // colors
  Colors: {
    keBlack: "#352944",
    keBasePurple: "#6A56D9",
    keBasePurpleDull: "#7B7EAD",
    keTextPurple: "#5B5F99",
    keTextPurpleFaint: "#B2B4D4",
    keBkgPurple: "#F0EEFB",
    keButtonPurple: "#352944",
    keBkgGrey: "#F9F9FB",
    keBaseTeal: "#15E5E1",
  },
}
